import * as R from 'ramda';

const getCheckedFilterValue = (filters: { name?: string[]; code?: string[] }) =>
    Object.entries(filters).reduce(
        (
            acc: {
                and?: { [key: string]: { or: { eq: string }[] } };
            },
            [key, value],
        ) => {
            if (value?.length) {
                acc = {
                    and: {
                        ...acc?.and,
                        [key]: {
                            or: value?.map((item) => ({
                                eq: item,
                            })),
                        },
                    },
                };
            }

            return acc;
        },
        {},
    );

export const getWhere = (filters: { searchString?: string; code?: string[]; name?: string[] }): any => {
    const { searchString, ...rest } = filters;

    const filtersWhere = getCheckedFilterValue(rest);

    const searchStringWhere = searchString && {
        or: [
            {
                code: { containsi: searchString },
            },
            {
                name: {
                    containsi: searchString,
                },
            },
        ],
    };

    if (searchStringWhere && !R.isEmpty(filtersWhere)) {
        return {
            and: [searchStringWhere, filtersWhere],
        };
    }

    if (searchStringWhere) {
        return searchStringWhere;
    }

    if (!R.isEmpty(filtersWhere)) {
        return filtersWhere;
    }

    return undefined;
};
